export const objectiveActionsTableColumns = [
  { label: 'Nome da Ação', value: 'display_name', className: 'w-56' },
  { label: 'Descrição', value: 'description' },
  { label: 'Ações', value: 'actions', className: 'w-11' },
];
